module.exports = __webpack_public_path__ + "img/datarutas.098a7deb.svg";